import TBTC from "./tBTC"

export const pages = [TBTC]
